import axios from './axios';

const getDashboard = async () => {
	const response = await axios.get('/dashboard');
	return response.data;
};

export { getDashboard };
